export default __webpack_public_path__ + "static/page-header-do-2-809ac5820da6690603c0b2bcaebcf9c7.png";